"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgActionEdit02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "M16 26.667h12m-24 0h2.233c.652 0 .978 0 1.285-.074.272-.065.532-.173.77-.32.27-.164.5-.395.962-.856L26 8.667a2.828 2.828 0 1 0-4-4L5.25 21.417c-.462.461-.692.692-.857.96a2.7 2.7 0 0 0-.32.772C4 23.456 4 23.782 4 24.434z" }))); };
exports.default = SvgActionEdit02;
//# sourceMappingURL=ActionEdit02.js.map